export default {
  position: 'relative',
  zIndex: '1',
  color: '#03A9F4',
  textShadow: 'white 1px 0px 1px, white -2px -1px 1px, white -1px -1px 1px, white 1px 1px 1px',
  textDecoration: 'none',
  pointerEvents: 'none'
  }